import urljoin from 'url-join';
import axios from 'axios';
import { BusinessLocation } from '../models/businessLocation';

class GoogleMyBusinessApi {
	public async getLocations(accessToken: string, accountId: string): Promise<BusinessLocation[]> {
		const url = urljoin('https://mybusinessbusinessinformation.googleapis.com/v1/accounts', accountId, 'locations');
		const headers = {
			Authorization: `Bearer ${accessToken}`
		};
		return axios.get(url, { headers });
	}
}

export const googleMyBusinessApi = new GoogleMyBusinessApi();
